export const OKTA_ORIGINS = [
  'https://id-dev.standards.org.au',
  'https://id-test.standards.org.au',
  'https://id-uat.standards.org.au',
  'https://id.standards.org.au'
];


export const OKTA_PATH = '/samlp';


export const SALESFORCE_ALLOWLIST = [
  'https://standards--sadev.sandbox.my.site.com',
  'https://standards--sadev.sandbox.my.salesforce.com',
  'https://standards--satest.sandbox.my.salesforce.com',
  'https://standards--satest.sandbox.my.site.com',
  'https://standards--uat.sandbox.my.salesforce.com',
  'https://standards--uat.sandbox.my.site.com',
  'https://standards.my.salesforce.com',
  'https://standards.my.site.com',
];


export const ALLOWED_PARAMS = ['SAMLRequest', 'RelayState', 'SigAlg'];
